import React from 'react'
import '../css/footer.css'

const Footer = () => {
    return (
        <div id="footer">
            <hr/>
            <p>&copy; Copyright 2022 David Tran. All trademarks and logos used are the property of their respective owners. </p>
        </div>
    )
}

export default Footer
